import KinvaTemplatePage from "./KinvaTemplatePage";

export {KinvaTemplatePage}
export default KinvaTemplatePage
